







import { Component, Vue } from 'vue-property-decorator';
import TypeBrowser from '@/components/LeaveTypes/TypeBrowser.vue';
import RequestsService from '@/mixins/requests.service';

@Component({
  components: {
    TypeBrowser,
  },
})
export default class LeaveTypes extends Vue {

}
